import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getPinInfo } from '@/help.search';
import Help from "@/Help";
import OpeningHours from '@/openingHours';
var PaymentTypes;
(function (PaymentTypes) {
    PaymentTypes[PaymentTypes["OnFoot"] = 1] = "OnFoot";
    PaymentTypes[PaymentTypes["PayAndDisplay"] = 2] = "PayAndDisplay";
    PaymentTypes[PaymentTypes["Contract"] = 3] = "Contract";
    PaymentTypes[PaymentTypes["Free"] = 4] = "Free";
    PaymentTypes[PaymentTypes["PayOnExit"] = 5] = "PayOnExit";
    PaymentTypes[PaymentTypes["PayOnEntry"] = 6] = "PayOnEntry";
    PaymentTypes[PaymentTypes["Barrier"] = 7] = "Barrier";
    PaymentTypes[PaymentTypes["PayByPhone"] = 8] = "PayByPhone";
    PaymentTypes[PaymentTypes["Contactless"] = 9] = "Contactless"; //new 2024-07-17
})(PaymentTypes || (PaymentTypes = {}));
var PhysicalTypes;
(function (PhysicalTypes) {
    PhysicalTypes[PhysicalTypes["LiftOperated"] = 1] = "LiftOperated";
    PhysicalTypes[PhysicalTypes["MultiStorey"] = 2] = "MultiStorey";
    PhysicalTypes[PhysicalTypes["MultiSurface"] = 3] = "MultiSurface";
    PhysicalTypes[PhysicalTypes["RoofTop"] = 4] = "RoofTop";
    PhysicalTypes[PhysicalTypes["SurfaceUrban"] = 5] = "SurfaceUrban";
    PhysicalTypes[PhysicalTypes["SurfaceRural"] = 6] = "SurfaceRural";
    PhysicalTypes[PhysicalTypes["Underground"] = 7] = "Underground";
    PhysicalTypes[PhysicalTypes["Surface"] = 8] = "Surface";
    //Other, //TODO:TD this was added for standalone Park Access from CSV work as they had specified other in the CSV... NO BUENO going forward
})(PhysicalTypes || (PhysicalTypes = {}));
var VehicleTypes;
(function (VehicleTypes) {
    VehicleTypes[VehicleTypes["Cars"] = 1] = "Cars";
    VehicleTypes[VehicleTypes["Cycles"] = 2] = "Cycles";
    VehicleTypes[VehicleTypes["Motorcycles"] = 3] = "Motorcycles";
    VehicleTypes[VehicleTypes["Lorries"] = 4] = "Lorries";
    VehicleTypes[VehicleTypes["Coaches"] = 5] = "Coaches";
    //Buses
})(VehicleTypes || (VehicleTypes = {}));
let ResultSelected = class ResultSelected extends Vue {
    constructor() {
        super(...arguments);
        this.showTimes = false;
    }
    toggle() {
        this.$emit('result-toggle', this.data.id);
    }
    get pinClass() {
        return getPinInfo(this.data).pinClass; //TODO:MAP 
    }
    get pinTitle() {
        return getPinInfo(this.data).pinTitle;
    }
    directions() {
        var googleUrl = `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${this.nameAddressEncoded}`; // `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(carParkNameAndAddress)}`;
        window.open(googleUrl); //, '_blank');
    }
    share() {
        this.$emit('result-share-click', this.data.id);
    }
    visitToBook() {
        window.open(this.data.bookingUrl);
    }
    get nameAddressEncoded() {
        var carParkNameAndAddress = `${this.data.name}, ${this.data.address}`;
        return encodeURI(carParkNameAndAddress.replace(" ", "+"));
    }
    get timesLengthIs7() {
        if (OpeningHours.getAllDayTimes(this.data).length === 7) {
            return true;
        }
        return false;
    }
    get timesToggleTitle() {
        return this.showTimes ? "Hide opening hours" : "Show opening hours";
    }
    get classes() {
        return `${(!this.sticky) ? "" : "sticky"} ${this.showTimes ? "show_times" : ""} ${this.timesLengthIs7 ? "times7" : "times1"}`;
    }
    toggleTimes() {
        this.showTimes = !this.showTimes;
    }
    get bookingPossible() {
        return !Help.isNullOrEmpty(this.data.bookingUrl);
    }
    get paymentTypesText() {
        if (this.data.paymentTypes == null) {
            console.log(this.data.id + " is missing paymentTypes");
            return "Not Known";
        }
        return this.data.paymentTypes.map(Converter.paymentTypeToString).join(", ");
    }
    get physicalTypesText() {
        if (this.data.physicalTypes == null) {
            console.log(this.data.id + " is missing physicalTypes");
            return "Not Known";
        }
        return this.data.physicalTypes.map(Converter.physicalTypeToString).join(", ");
    }
    get vehicleTypesVisible() {
        return this.data.vehicleTypes.filter(v => v != VehicleTypes.Cars).length > 0;
    }
    get openingHoursSummaryText() {
        return OpeningHours.getSummary(this.data);
    }
    get openingHoursDropdownText() {
        return OpeningHours.getAllDayTimes(this.data);
    }
    getVehicleTypeText(vehicleType) {
        return VehicleTypes[vehicleType];
    }
    getVehicleTypeIcon(vehicleType) {
        return Converter.vehicleTypeToFontawesomeIcon(vehicleType);
    }
    getVehicleTypeTitle(vehicleType) {
        return `Has bays for ${this.getVehicleTypeText(vehicleType)}`;
    }
};
tslib_1.__decorate([
    Prop()
], ResultSelected.prototype, "data", void 0);
tslib_1.__decorate([
    Prop()
], ResultSelected.prototype, "sticky", void 0);
ResultSelected = tslib_1.__decorate([
    Component
], ResultSelected);
export default ResultSelected;
class Converter {
    static paymentTypeToString(paymentType) {
        let respVal = "";
        if (paymentType === PaymentTypes.PayAndDisplay) {
            respVal = "Pay & Display";
        }
        else if (paymentType === PaymentTypes.PayOnExit) {
            respVal = "Pay on Exit";
        }
        else if (paymentType === PaymentTypes.PayOnEntry) {
            respVal = "Pay on Entry";
        }
        else if (paymentType === PaymentTypes.PayByPhone) {
            respVal = "Pay by Phone";
        }
        else {
            debugger;
            respVal = Help.splitOnCamelCase(PaymentTypes[paymentType]);
        }
        return respVal;
    }
    static physicalTypeToString(physicalType) {
        let respVal = "";
        if (physicalType === PhysicalTypes.MultiStorey) {
            respVal = "Multi-storey";
        }
        else if (physicalType === PhysicalTypes.MultiSurface) {
            respVal = "Multi/Surface";
        }
        else if (physicalType === PhysicalTypes.SurfaceUrban) {
            respVal = "Surface-Urban";
        }
        else if (physicalType === PhysicalTypes.SurfaceRural) {
            respVal = "Surface-Rural";
        }
        else {
            respVal = Help.splitOnCamelCase(PhysicalTypes[physicalType]);
        }
        return respVal;
    }
    static vehicleTypeToFontawesomeIcon(vehicleType) {
        let respVal = "";
        if (vehicleType === VehicleTypes.Cycles) {
            respVal = "fas fa-biking";
        }
        else if (vehicleType === VehicleTypes.Lorries) {
            respVal = "fas fa-truck-moving"; //OR "fas fa-truck";
        }
        else if (vehicleType === VehicleTypes.Coaches) {
            respVal = "fas fa-shuttle-van";
        }
        else {
            respVal = Help.trimEndCharacters(VehicleTypes[vehicleType].toLowerCase(), "s");
        }
        return `fas fa-${respVal}`;
    }
}
